import { useState, useEffect } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Typography,
    IconButton,
    Box,
} from "@mui/material";
import { CloseOutlined, ChecklistOutlined } from "@mui/icons-material";
import CheckCircle from "@mui/icons-material/CheckCircle";

import ForgotPasswordForm from "../forms/ForgotPasswordForm";
import { useSendPasswordResetEmail } from "../../hooks/authHooks";

const ForgotPasswordPopup = ({ onClose, onRegister }) => {
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const {
        mutate: sendPasswordResetEmail,
        isPending: isEmailSending,
        error: sendPasswordResetEmailError,
        data: sendPasswordResetEmailData,
    } = useSendPasswordResetEmail();

    const handleSubmit = (values) => {
        const formData = {
            email: values.email
        };

        sendPasswordResetEmail(formData);
    };

    useEffect(() => {
        if (sendPasswordResetEmailData) {
            setErrorMessage("");
            setSuccessMessage(sendPasswordResetEmailData.message);
        }
    }, [sendPasswordResetEmailData]);

    useEffect(() => {
        if (sendPasswordResetEmailError) {
            setSuccessMessage("");
            setErrorMessage("Invalid email address. Please try again.");
        }
    }, [sendPasswordResetEmailError]);



    return (
        <Dialog open={true} maxWidth="sm" fullWidth>
            <DialogTitle>
                Forgot Password
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseOutlined />
                </IconButton>
            </DialogTitle>

            {sendPasswordResetEmailData && (
                <DialogContent>
                    <Box
                        variant="body2"
                        sx={{
                            mb: 2,
                            display: 'flex',
                            fontWeight: 500,  // Make the text a little bolder
                            color: 'text.primary',  // Ensure the text color matches the theme
                        }}
                    >
                        <CheckCircle
                            sx={{
                                mr: 1,  // Space between the icon and text
                                fontSize: '1.25rem',  // Icon size
                                color: 'success.main',  // Success color for the icon
                            }}
                        />
                        <Typography>
                            An email has been sent to <strong>{sendPasswordResetEmailData.email}</strong> with a link to reset your password.
                        </Typography>
                    </Box>
                </DialogContent>

            )}

            {!sendPasswordResetEmailData && (
                <>

                    {errorMessage && (
                        <DialogContent>
                            <Typography variant="body1" color="error">{errorMessage}</Typography>
                        </DialogContent>
                    )}

                    <DialogContent>
                        <Typography variant="body2">
                            Enter your email address to receive a password reset link
                        </Typography>
                    </DialogContent>

                    <DialogContent>
                        <ForgotPasswordForm isEmailSending={isEmailSending} onClose={onClose} onRegister={onRegister} onSubmit={handleSubmit} />
                    </DialogContent>
                </>
            )}

        </Dialog>
    );
};

export default ForgotPasswordPopup;